/**
 * list of recurrent constants
 */

export const DOMAIN = 'dmn';
export const COMPONENT = 'cmp';
export const USER = 'user';
export const GROUP = 'group';
export const DATA_PRODUCT = 'dp';
export const SYSTEM_TYPE = 'systemtype';
export const RESOURCE = 'rsr';
export const RELEASE = 'release';
export const SYSTEM = 'system';
export const USE_CASE_TEMPLATE = 'utm';
export const TAXONOMY = 'taxonomy';
export const INFRASTRUCTURE_TEMPLATE = 'itm';

export const WITBOOST_NAME = 'witboost';
export const CATALOG = 'catalog';

export const URN = 'urn';
export const DMB = 'dmb';

export const MAX_HTTP_PAYLOAD_SIZE_MB = 10;
export const DEFAULT_BASE_TEMP_PATH = '/tmp';
export const PLATFORM_ENTITY_REF = 'platform:witboost';
export const GUEST_USER_REF = 'user:development/guest';

export const INFRASTRUCTURE_TEMPLATE_PREFIX = `${URN}:${DMB}:${INFRASTRUCTURE_TEMPLATE}`;
